import { FC } from "react";

interface IconProps {
  color?: string;
}

export const Check: FC<IconProps> = ({ color = "#fff" }) => (
  <svg viewBox="0 0 10 9" stroke={color} xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8.419 1.8 3.918 7.286l-2.7-2.336"
      fill="none"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
